module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "poll-none"
  }, [_c('div', {
    staticClass: "box-poll"
  }, [_c('div', {
    staticClass: "topic"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.topic) + "\n\t\t\t")]), _vm._v(" "), _vm._l((_vm.poll.choices), function(choice) {
    return [_c('div', {
      staticClass: "choice dash-bg-color-skin-light-50"
    }, [_c('div', {
      staticClass: "dash-bg-color-skin-light-10",
      class: 'progress' + choice.progress
    }), _vm._v(" "), _vm._m(0, true)])]
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choosentext"
  }, [_c('i', [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-box"
  }, [_c('div', {
    staticClass: "date-poll dash-color-skin"
  }, [_vm._v("00/00/0000 - 00/00/0000")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-clock-o dash-color-skin",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "penguin"
  }, [_c('img', {
    attrs: {
      "src": require("static/poll/penguin.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a438061!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/poll/none.vue
// module id = 3687
// module chunks = 1